import Collection from '@arcgis/core/core/Collection';
import { CheckboxNode } from '@jeppesen-foreflight/jmkw-toolkit';
import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { NavigationPseudoLayer } from './navigation.pseudo-layer';

export function convertPseudoLayersToCheckboxNodeMap(
  pseudoLayers: Collection<NavigationPseudoLayer>,
  expanded = false
): ExtendedMap<CheckboxNode> {
  const checkboxMap = new ExtendedMap<CheckboxNode>();
  for (const pseudoLayer of pseudoLayers) {
    checkboxMap.set(
      pseudoLayer.id,
      convertPseudoLayerToCheckboxNode(pseudoLayer, expanded)
    );
  }
  return checkboxMap;
}

function convertPseudoLayerToCheckboxNode(
  pseudoLayer: NavigationPseudoLayer,
  expanded?: boolean
): CheckboxNode {
  const node = new CheckboxNode({
    id: pseudoLayer.id,
    label: pseudoLayer.label,
    selected: pseudoLayer.visible,
    expanded,
    order: pseudoLayer.zOrder,
    automationKey: `${pseudoLayer.id}-checkbox`
  });

  if (pseudoLayer.layers) {
    for (const childLayer of pseudoLayer.layers) {
      if (childLayer instanceof NavigationPseudoLayer) {
        node.children.set(
          childLayer.id,
          convertPseudoLayerToCheckboxNode(childLayer, expanded)
        );
      }
    }
    if (node.children.size) {
      const children = [...node.children.values()];
      node.selected = children.every((child) => child.selected);
      node.indeterminate =
        !node.selected && children.some((child) => child.selected);
    }
  }
  return node;
}
